module.exports = {
      id: "charge-l2-usage",
      viewBox: "0 0 45 20",
      url: __webpack_public_path__ + "assets/img/sprite-8cafc1.svg#charge-l2-usage",
      toString: function () {
        return this.url;
      }
    }